import React from 'react'

export default function Hero() {
  return (
    <>
     <section id="hero" className="d-flex align-items-center">
          <div className="container" data-aos="zoom-out" data-aos-delay="100">
            <h1>Welcome To<span><br/> Pune Institute of Computer Technology, Pune</span></h1>
            <h2>Campus Selection System Website</h2>
          </div>
        </section>
    </>
  )
}
